import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCanvasGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCanvasGrid"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M12 3.5V6.5M12 20.5V17.5M3.5 12H6.5M20.5 12H17.5" stroke="currentColor"/><Path d="M9 12H15M12 9V15" stroke="currentColor"/></CentralIconBase>;
});

export default IconCanvasGrid;
